import {Injectable} from "@angular/core";
import {BaseRestService} from "./baseRestService";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {Observable} from "rxjs";
import {Address} from "../../classes/Address";

@Injectable({
    providedIn: 'root'
})

export class RestAddressService extends BaseRestService {
    private readonly BASE_URL: string;

    constructor(private http: HttpClient) {
        super();
        this.BASE_URL = environment.restApiUrl + '/Address';
    }

    getList(search: string, requireEastingNorthing: boolean): Observable<Address[]> {
        const url = `${this.BASE_URL}/List`;
        const params = {search: search, requireEastingNorthing: requireEastingNorthing};
        return this.http.get<Address[]>(url, {headers: this.authHeadersV2, params});
    }
}